<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "app",
		components: {

		},
		data() {
			return {

			};
		},
		 created() {
				
			
			
				
					
					
				   
			
				
		  },
		methods: {


		}
	};
</script>

<style>
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		border: 0;
		outline: none;
	}

	#nprogress .bar {
		background: #9E819F !important;
	}




	.ns-footer {
		box-sizing: border-box;
		text-align: center;
		padding-bottom: 50px;
		padding-top: 150px;
		line-height: 1.8;
		color: #999;
		background: #f8f8f8;
	}

	.ns-footer a {
		color: #999;
	}

	.ns-footer-img,
	.ns-copyright,
	.ns-put-on-record {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.ns-footer-img {
		margin-bottom: 5px;
	}

	/*修改滚动条样式*/
	::-webkit-scrollbar {
		width: 3px;
		height: 3px;
		/**/
	}

	::-webkit-scrollbar-track {
		background: rgb(239, 239, 239);
		border-radius: 2px;
	}

	::-webkit-scrollbar-thumb {
		background: #bfbfbf;
		border-radius: 10px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #333;
	}

	::-webkit-scrollbar-corner {
		background: #179a16;
	}


	.dis{
		display:flex;
		justify-content:center;
		align-items:center;
	}
	
	
	.el-dialog{
		border-radius: 10px !important;
	}

</style>
